module.exports = __webpack_public_path__ + "b514c40c0fe4df7a5961351ee74d063b.png";